const { createSlice } = require('@reduxjs/toolkit');

const queryMultipleBalanceApiCall = async (params) => {
  let response = await fetch('/bizcareui/api/queryMultipleBalance', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body: params,
  }).then((response) => response.json());
  return response;
};

const OpenOrderApiCall = async (params) => {
  let response = await fetch('/bizcareui/api/OpenOrder', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body: params,
  }).then((response) => response.json());
  return response;
};
export function getFetchVDAccountAndBillingData(
  pageNumber = 1,
  itemPerPage = 5,
  phoneNum = '',
  qname = '',
  router,
  screen = '',
  ChildLines = false
) {
  return async function fetchVDAccAndbillingThunk(dispatch, getState) {
    try {
      const param = JSON.stringify({
        msisdn: phoneNum,
        source: 'BizCare',
        pageStart: pageNumber,
        pageCount: itemPerPage,
      });
      dispatch(getViewDetailBulkData({ data: {}, loading: true }));

      let response = await fetch(
        `/bizcareui/api/fetchOrgCustomerDetailsByMsisdn`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: param,
        }
      );
      let json = await response.json();
      if (!json.code) {
        // dispatch(
        //   getViewDetailBulkData({ data: json, loading: false, error: '' })
        // );
        let billingAccountNum = '';
        let params = '';
        let mobileNum = '';
        if (screen === 'BulkCallBar' || screen === 'BulkSimReplacement') {
          billingAccountNum = json[0].account.map((item) => {
            return {
              AccountNo: item.externalReference.find(ref => ref.externalReferenceType === "cbsAccountId")?.value,
              MobileNo: item?.serviceIdentifier
            };
          });
          const list = billingAccountNum.map((item) => {
            return {
              serialNumber: item?.MobileNo,
              billingAccountNumber: item?.AccountNo,
              operateType: 'PartnerPortal',
              groupId: '',
              startTime: '',
              endTime: null,
            };
          });
          params = JSON.stringify({
            listOfCmuRequestBillingProfileIo: {
              comInvoiceProfile: list,
            },
          });
        } else if (screen === 'InternetAllshare') {
          const billingAccountNumber =
            json[0]?.account[0]?.externalReference.find(ref => ref.externalReferenceType === "cbsAccountId")?.value;
          const smeGroupIdData = json[0]?.account[0]?.characteristic.find((char) => char.name === 'smeGroupId')?.value;
          const mobile = json[0]?.account?.[0]?.serviceIdentifier;
          params = JSON.stringify({
            listOfCmuRequestBillingProfileIo: {
              comInvoiceProfile: [
                {
                  billingAccountNumber: billingAccountNumber, //301019956 //cust[0].accountno 301045068--two month and one month
                  endTime: '',
                  groupId: smeGroupIdData, //563525204 //ApiData?.smeGroupId //648691267--two month and one month
                  operateType: 'DataDetails',
                  serialNumber: '',
                  startTime: '',
                },
              ],
            },
          });
        } else {
          billingAccountNum = json[0].account.map((item) => {
            return {
              AccountNo: item.externalReference.find(ref => ref.externalReferenceType === "cbsAccountId")?.value,
            };
          });
          const list = billingAccountNum.map((item) => {
            return {
              billingAccountNumber: item?.AccountNo,
              endTime: null,
              groupId: '',
              operateType: '',
              serialNumber: '',
              startTime: '',
            };
          });
          params = JSON.stringify({
            listOfCmuRequestBillingProfileIo: {
              comInvoiceProfile: list,
            },
          });
        }
        const result = await queryMultipleBalanceApiCall(params).then(result);
        console.log('result....in redux', result, screen);

        if (screen === 'BulkCallBar' || screen === 'BulkSimReplacement') {
          console.log('hereak');
          const list = [];
          mobileNum = json[0].account.map((item) => {
            return {
              MobileNo: !(item?.serviceIdentifier.includes("@")) ? "6" + item?.serviceIdentifier : item?.serviceIdentifier,
            };
          });
          const identification = json[0].organizationIdentification?.find((char) => char.referredType === 'customerIc');
          mobileNum?.map((item) => {
	    const isUsername = (item.MobileNo)?.includes("@") ? true : false;
            const externalReferenceObject = {
              externalReferenceType: "fiberUserName",
              value: item.MobileNo
            }
            params = JSON.stringify({
              orderCharacteristics: {
                productOffering: {
                  type: isUsername ? "Ent_Home_Fibre" : "Ent_Mobile"
                },
                orderType: isUsername ? "Product Change" : "SIM Change",
                paidFlag: "Postpaid"
              },
              relatedParty: {
                id: json[0].id,
                organizationIdentification: {
                  identificationId: identification ? identification.identificationId : null,
                  identificationType: "BRN"
                },
                ...(!isUsername)
                  ? { msisdn: item.MobileNo }
                  : { externalReference: externalReferenceObject }
              },
            });
            list.push(params);
          });

          const openOrderData =
            list &&
            list.map(async (params) => {
              const openOrderResult = await OpenOrderApiCall(params).then(
                result
              );
              return {
                query: await openOrderResult,
              };
            });
          dispatch(
            getViewDetailBulkData({ data: json, loading: false, error: '' })
          );
          await Promise.all(openOrderData).then((values) => {
            if (values) {
              dispatch(getOpenOrderResponse(values));
            } else {
              dispatch(
                getOpenOrderResponse({
                  data: [],
                  loading: false,
                  error: `Technical failure : Couldn't able to retrieve details`,
                  modalIsOpenError: true,
                })
              );
            }
            if (result) {
              dispatch(
                getQueryMultipleResponse({
                  data: result,
                  loading: false,
                  error: '',
                })
              );
              dispatch(
                getVDBtotalSize(
                  json[0].account.length
                )
              );
              dispatch(
                getViewDetailBulkData({ data: json, loading: false, error: '' })
              );
              if (
                !json.code &&
                result
              ) {
                if (screen) {
                  router.push({
                    pathname: `/${screen}`,
                    query: {
                      name: qname,
                      mobileNo: phoneNum,
                      supp: ChildLines,
                    },
                  });
                }
              }
            } else {
              dispatch(
                getQueryMultipleResponse({
                  data: [],
                  loading: false,
                  error: `Technical failure : Couldn't able to retrieve details`,
                  modalIsOpenError: true,
                })
              );
            }
          });
        } else {
          if (result) {
            dispatch(
              getQueryMultipleResponse({
                data: result,
                loading: false,
                error: '',
              })
            );
            dispatch(
              getVDBtotalSize(
                json[0].account.length
              )
            );
            dispatch(
              getViewDetailBulkData({ data: json, loading: false, error: '' })
            );
            if (
              !json.code &&
              result
            ) {
              if (screen === 'InternetAllshare') {
                router.push({
                  pathname: `/${screen}`,
                  query: { name: qname },
                });
              } else if (screen) {
                router.push({
                  pathname: `/${screen}`,
                  query: { name: qname, mobileNo: phoneNum, supp: ChildLines },
                });
              }
            }
          } else {
            dispatch(
              getQueryMultipleResponse({
                data: [],
                loading: false,
                error: `Technical failure : Couldn't able to retrieve details`,
                modalIsOpenError: true,
              })
            );
          }
        }
      } else if (json?.error) {
        dispatch(
          getViewDetailBulkData({
            data: [],
            loading: false,
            error: `Technical failure : Couldn't able to retrieve detail`,
            modalIsOpenError: true,
          })
        );
      }
    } catch (error) {
      dispatch(
        getViewDetailBulkData({
          data: [],
          loading: false,
          error: `Technical failure : Couldn't able to retrieve detail`,
          modalIsOpenError: true,
        })
      );
    }
  };
}

export function getDisableBulkActions(json, BAUOfferingIds) {
    const relatedEntities = json?.relatedEntity || [];
  console.log(relatedEntities,"RELATED_ENTITY");
    for (const entity of relatedEntities) {
      const productOfferings = entity?.productOffering || [];
      for (const offering of productOfferings) {
        if (offering?.type === 'supplementary') { 
          const specId = offering?.productSpecification[0]?.id;
          if (BAUOfferingIds.includes(specId)) {
            return true;
          }
        }
      }
 
    }
    return false;
  }

const initialState = {
  itemPerPage: 5,
  pageNumber: 1,
  totalSize: 0,
  viewDetailsBulkData: {
    data: {},
    loading: false,
    error: '',
    modalIsOpenError: false,
  },
  viewDetailQueryMultipleResDetails: {
    data: {},
    loading: false,
    error: '',
    modalIsOpenError: false,
  },
  viewDetailOpenOrderResDetails: {
    data: {},
    loading: false,
    error: '',
    modalIsOpenError: false,
  },
  VDBReplicatedData: [],
};
const viewDetailBulk = createSlice({
  name: 'getViewDetailBulk',
  initialState,
  reducers: {
    getViewDetailBulkData: (state, action) => {
      state.viewDetailsBulkData = action.payload;
    },
    getQueryMultipleResponse: (state, action) => {
      state.viewDetailQueryMultipleResDetails = action.payload;
    },
    getOpenOrderResponse: (state, action) => {
      state.viewDetailOpenOrderResDetails = action.payload;
    },
    getItemPerPage: (state, action) => {
      state.itemPerPage = action.payload;
    },
    getpageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    getVDBtotalSize: (state, action) => {
      state.totalSize = action.payload;
    },
    getVDBReplicatedData: (state, action) => {
      // console.log(
      //   '--------------------------->',
      //   action.payload,
      //   state.VDBReplicatedData,
      //   state
      // );
      if (action.payload === undefined && state.VDBReplicatedData?.length > 0) {
        state.VDBReplicatedData.length = 0;
      } else if (
        state.VDBReplicatedData?.length > 0 &&
        action.payload.length > 0
      ) {
        state.VDBReplicatedData = [
          ...state.VDBReplicatedData,
          ...action.payload,
        ];
      } else if (
        state.VDBReplicatedData?.length === 0 ||
        state.VDBReplicatedData === undefined
      ) {
        state.VDBReplicatedData = action.payload;
      } else {
        // state.VDBReplicatedData.length = 0;
        state.VDBReplicatedData = [];
      }
    },
    resetViewDetailBulk: () => initialState,
  },
});
export const {
  getViewDetailBulkData,
  getQueryMultipleResponse,
  getOpenOrderResponse,
  getItemPerPage,
  getVDBtotalSize,
  getpageNumber,
  getVDBReplicatedData,
  resetViewDetailBulk,
} = viewDetailBulk.actions;
export default viewDetailBulk.reducer;
